import { createPortal } from 'react-dom';
import { v4 as uuid } from "uuid";
import React, { useEffect, useState, useRef} from "react";
import store from "@/redux/store";
import { useDrag } from "./useDrag";

import { open, close, setPos,setFocus } from '@/reducers/Window'
import { XCircleIcon,ArrowsPointingOutIcon, ArrowUpLeftIcon } from '@heroicons/react/20/solid'
import PPCEvent, { WINDOW_EVENTS } from '@/Events/Event'

const baseWindow= window;

const BaseWindow =  React.memo(function({...props})  {
    
 const draggableRef = useRef(null);
  const { position, handleMouseDown } = useDrag({windowPanel: props?.window,
    ref: draggableRef
  });
    const[updateKey, setUpdateKey]  = useState( uuid() );
    const[resizePanel, setResizePanel]  = useState(false);
    let timerEvents = props?.ppcEventClass; //new PPCEvent();
    let panelRect = null;
      
    const TYPE= {
        NORMAL: 0,
        MAX : 1,
        CLOSE: 2,
        INIT: 3,
    }
    
    const checkSizeWindow = () => {
        if(props?.window && props?.window?.startWidth > baseWindow.outerWidth) { 
             props.window.startWidth = baseWindow.outerWidth - 120;
        }
    }
    
    const sizeWindowEvent=(event)=> {
        timerEvents.dispatch(WINDOW_EVENTS.MAX_WINDOW, props?.window);
        return false;
        }    
      
    const addNewWindow=(event)=> {
            store.dispatch( open({}) );
        return false;
    }

    let resizeWindow = (event) => {
        event.preventDefault();
        let windowId = props?.window.uid;
        let windowLoaded = document.getElementsByName('base_'+windowId);
        if(props?.window && props?.window?.resizeElements) {
        
            props?.window?.resizeElements.for( (item) => {
                let otherPanel = document.getElementById(item+"_"+windowId);
                if(otherPanel && windowLoaded && windowLoaded?.style) {
                    otherPanel.style.height = (windowLoaded.style.height - otherPanel.offsetTop - 8)+"px"; 
                }
                
            } )    
        }
        
        
        if(event.type == WINDOW_EVENTS.MAX_WINDOW) {
            if(event.detail.uid == props?.window?.uid) {
                let windowRect = document.body.getBoundingClientRect();

                let windowId = props?.window.uid;
                //let windowLoaded = draggableRef.current.querySelector('[name="'+windowId+'"]');
                //let windowLoaded = document.getElementsByName(windowId);
                //let windowLoaded = document.getElementsByName('base_'+windowId);
                
                
                windowLoaded = windowLoaded[0];
                if(!panelRect && windowLoaded) {
                    panelRect = windowLoaded.getBoundingClientRect();
                    let prevPropsWindow = {width: panelRect.width, height:panelRect.height, left: panelRect.x, top: panelRect.y};
                    props?.window?.setData('oldPos', prevPropsWindow  );
                draggableRef.current.style.width = (windowRect.width)+"px";                
                draggableRef.current.style.height = (windowRect.height)+"px";
                draggableRef.current.style.left = "0px";
                draggableRef.current.style.top = "0px";
                
//                    windowLoaded.style.width = (windowRect.width)+"px";                
//                    windowLoaded.style.height = (windowRect.height)+"px";
                    windowLoaded.style.left = "0px";
                    windowLoaded.style.top = "0px";
                } else if(windowLoaded) {
                    windowRect = panelRect; //props?.window?.data?.oldPos;
                    windowRect = (props?.window?.data?.oldPos);
                    let top = windowRect.top;
                    if(top < 0) {
                        top = 0;
                    }
                    draggableRef.current.style.width = (windowRect.width)+"px";                
                    draggableRef.current.style.height = (windowRect.height)+"px";
                    draggableRef.current.style.left = windowRect.left+"px";
                    draggableRef.current.style.top = top+"px";
                    
                    windowLoaded.style.left = windowRect.left+"px";
                    windowLoaded.style.top = top+"px";
                    windowLoaded.style.height = (windowRect.height)+"px";
                    windowLoaded.style.width = (windowRect.width)+"px";
                    //props?.window?.setData2('oldPos', null);
                    panelRect = null;
                    
                }

                if(window && window?.resizeElements) {
                    let windowId = window.uid;
                    window?.resizeElements.for( (item) => {
                        
                        let otherPanel = document.getElementById(item+""+windowId);
                        if(otherPanel) {
                            otherPanel.style.height = (height)+"px"; 
                        }
                        
                    } )    
                }
                
                
            }
            //setResizePanel(true);
            return false;            
        } else {
            
            //setResizePanel(true);
        }
      };

      useEffect(() => {
        if(props?.window) {
            //props.ppcEventClass.setElement( 'base_'+props.window.uid );
            setWindow(props.window, TYPE.INIT);
        }
        window.addEventListener("resize", resizeWindow);
        window.addEventListener(WINDOW_EVENTS.SELECTED_WINDOW, setSelectedWindow);
        //props.ppcEventClass.add(WINDOW_EVENTS.LOADED, windowIsLoaded)
        props.ppcEventClass.add(WINDOW_EVENTS.MAX_WINDOW, resizeWindow, true);
        
        onFocusEvent(null);
        //timerEvents.add(WINDOW_EVENTS.CLOSE_WINDOW, closeWindow)
        return () => {
            window.removeEventListener("resize", resizeWindow);
            window.removeEventListener(WINDOW_EVENTS.SELECTED_WINDOW, setSelectedWindow);
            props.ppcEventClass.destroy();
            }
      }, []);    
    
      const setWindowPos = (windowId) => {
        let baseWindowLoaded = document.getElementsByName('base_'+windowId)[0];
        let windowLoaded = document.getElementsByName(windowId);
        if(baseWindowLoaded && windowLoaded.length > 0) {
            let baseWindowLoadedRect = baseWindowLoaded.getBoundingClientRect();
            let newYPos = (baseWindowLoadedRect.top+window.scrollY) - (baseWindowLoadedRect.height/2);
            if(newYPos < 0) {
                newYPos = 0;
            }

            baseWindowLoaded.top = newYPos+'px';
            draggableRef.current.style.top = newYPos+'px';
            
            baseWindowLoadedRect = baseWindowLoaded.getBoundingClientRect();
            props.window.setPosition( baseWindowLoadedRect )
        }
        
      }
      
      const setSelectedWindow = (event) => {
        event.preventDefault();
        let windowId = props?.window?.uid;
        
        let baseWindowLoaded = document.getElementById('base_'+windowId);
        calculatePosition();
        if(windowId == event.detail.window.uid) {
            if(baseWindowLoaded) {
                baseWindowLoaded.style.zIndex = 999;
            }
        } else if (baseWindowLoaded) {
            baseWindowLoaded.style.zIndex = 900 + props?.window?.index;
        }
        
        return false;
        }
      
      const windowIsLoaded = (event) => {
        
        let windowId = event.detail.window.uid;
        let footerPanel = document.getElementById("endPanel_"+windowId);
        if(windowId ) {
            //setFooterPanel( event.detail?.window?.footer );
            setUpdateKey(uuid());
        }
        
        calculatePosition();
        if(props.window && props.window.uid == windowId) {
            setWindow(event.detail.window, TYPE.INIT);
            
            
            if(props?.window && props?.window?.resizeElements) {
                let baseWindowLoaded = document.getElementById("base_"+windowId);
                props?.window?.resizeElements.for( (item) => {
                    let otherPanel = document.getElementById(item+"_"+windowId);
                    if(otherPanel) {
                        let basePanelHeight = baseWindowLoaded.style.height;
                        if(basePanelHeight.endsWith("%") ) {
                                        let windowRect = document.body.getBoundingClientRect();
                                        basePanelHeight = ( windowRect.height/100 ) * parseInt( basePanelHeight );
                                    }                        
                        otherPanel.style.height = (basePanelHeight - otherPanel.offsetTop - 8)+"px"; 
                    }
                    
                } )    
            }
            
            //mouseMovResizeHandler(event);
        }
        return;
        //let windowLoaded = draggableRef.current.querySelector('[name="'+windowId+'"]');
        let windowLoaded = document.getElementById(windowId);
        if(windowLoaded) {
            let windowLoadedRec = windowLoaded.getBoundingClientRect();
            if(windowLoaded && windowLoaded?.dataset) {
                if (windowLoaded.dataset.maxwidth !== undefined) {
                    setWindowSize( (windowLoaded.dataset.maxwidth) );
                } else {
                    setWindowSize( windowLoadedRec.width );                
                }
            }
        setWindowPos(windowId);
        return;
        let baseWindowLoaded = document.getElementsByName('base_'+windowId)[0];
        if(baseWindowLoaded) {
            let baseWindowLoadedRect = baseWindowLoaded.getBoundingClientRect();
            let newYPos = baseWindowLoadedRect.y - (baseWindowLoadedRect.width/2);
            baseWindowLoaded.y = newYPos+'px';
            draggableRef.current.style.y = newYPos+'px';    
        }
            };      
 }
 props.ppcEventClass.add(WINDOW_EVENTS.LOADED, windowIsLoaded, true);

   const setWindow = (window, type = TYPE.NORMAL) => {
    let windowId = window.uid;
    let baseWindowLoaded = document.getElementById("base_"+windowId);
    let windowLoaded = document.getElementById(windowId);
    if(windowLoaded) {
            let windowLoadedRec = baseWindowLoaded.getBoundingClientRect(); //windowLoaded.getBoundingClientRect();
            console.group("SET WINDOW");
            console.info("document", baseWindow.outerHeight);
            console.info("document", baseWindow.outerWidth);
            console.info("document", window);
            console.info("window "+type+" "+windowId, windowLoadedRec);

            if(window.startWidth > baseWindow.outerWidth || !window.startWidth) {
                window.startWidth = baseWindow.outerWidth-20;
            }           
            if(window.startHeight > baseWindow.outerHeight || !window.startHeight) {
                window.startWidth = baseWindow.outerHeight-20; 
            }           
            
                        
        if(type == TYPE.NORMAL) {
            setWindowSize( windowLoadedRec.width, windowLoadedRec.height, baseWindowLoaded );
        } else if(type == TYPE.INIT) {
            let startWidth = windowLoadedRec.width;
            if(window.startWidth) {
               startWidth = window.startWidth;
            }
            let startHeight = windowLoadedRec.height;
            if(window.startHeight) {
               startHeight = window.startHeight;
            }
            baseWindowLoaded.style.width = startWidth+"px";
            baseWindowLoaded.style.height = startHeight+"px";

            windowLoaded.style.width = startWidth+"px";
            windowLoaded.style.height = startHeight+"px";

            
                        
            
//            setWindowSize( startWidth, startHeight, baseWindowLoaded );
        } else if(type == TYPE.MAX) {
            let windowRect = document.body.getBoundingClientRect();
            setWindowSize( windowRect.width, windowRect.height );
            setWindowPosition(0,0);
        }
        
        
        if(window && window?.resizeElements) {
            
            let windowId = window.uid;
            window?.resizeElements.for( (item) => {
                
                let otherPanel = document.getElementById(item+"_"+windowId);
                
                if(otherPanel) {
                    otherPanel.style.height = (baseWindowLoaded.style.height - otherPanel.offsetTop - 8)+"px"; 
                }
                
            } )    
        }
        
    }
    console.groupEnd();
  }
  
  const setWindowSize = (width, height, window) =>  {
    let windowRect = document.body.getBoundingClientRect();
    
    if(width) {
        if(width > windowRect.width) {
            width = windowRect.width;
        }
        if(draggableRef?.current) {
            draggableRef.current.style.width = (width)+"px";
        }
        if(window) {
            window.style.width = (width)+"px";
        }
    }
    if(height) {
        if(height > windowRect.height) {
            height = windowRect.height;
        }
        if(draggableRef?.current) {
        draggableRef.current.style.height = (height)+"px";
        }
        //draggableRef.current.style.maxHeight = (height)+"px";
        if(window) {
            window.style.height = (height)+"px";
            //window.style.maxHeight = (height)+"px";
        }
    }
  }
  const calculatePosition = () => {
    console.debug("CALC")
    setTimeout( function() {
        
              const {window} = props;
              let windowId = window.uid;
              let baseWindowLoaded = document.getElementById("base_"+windowId);
        if(document && baseWindowLoaded) {
                let innerPanel = document.getElementById("innerPanel_"+windowId);
                let footerPanel = document.getElementById("endPanel_"+windowId);
                if(footerPanel) {
                    if(!window?.panelHeight) {
                        let progressBar = document.getElementById("progressBar");
                        let startPos = 0;
                        if(progressBar) {
                            startPos = progressBar.offsetHeight; //+ item.parentElement.childNodes[0].offsetTop;
                        }
                        
                    window.panelHeight = ((baseWindowLoaded.offsetHeight - footerPanel.offsetHeight) - innerPanel.offsetTop) - startPos;
                    }
                    innerPanel.style.height = ((baseWindowLoaded.offsetHeight - footerPanel.offsetHeight) - innerPanel.offsetTop) + "px";
                } 
                
              let windowLoaded = document.getElementById(windowId);
              
              
              if(!window.y && document.documentElement.offsetHeight > baseWindowLoaded.offsetHeight) {
                let ySpace = document.documentElement.offsetHeight - baseWindowLoaded.offsetHeight;
                let newYpos = ySpace/2;
                baseWindowLoaded.style.top = newYpos+"px";
                }
              
              if(!window.x && document.documentElement.offsetWidth > baseWindowLoaded.offsetWidth) {
                let xSpace = document.documentElement.offsetWidth - baseWindowLoaded.offsetWidth;
                let newXpos = xSpace/2;
                baseWindowLoaded.style.left = newXpos+"px";
              }
              
              const dynamicPanels = document.querySelectorAll(`[data-dynamic]`);
              if(dynamicPanels && footerPanel) {
                let heightDynamicPanels = baseWindowLoaded.offsetHeight;
                dynamicPanels.forEach((item) => {
                    let startPos = 0;
                    
                    //item.style.height = ((innerPanel.style.height - item.offsetTop) - footerPanel.offsetHeight)+"px";
                    item.style.height = window.panelHeight-50+"px";
                    
                    
                })
              }
              
              
          }  
        
        
    }.bind(this), 20);
    

      
            
  }

  const setWindowPosition = (x, y) =>  {
    let windowRect = document.body.getBoundingClientRect();
    
    if(x > 0) {
        if(x < 0 ) {
            x = 0;
        }
        if(draggableRef?.current) {
        draggableRef.current.style.left = (x)+"px";
        }
        //draggableRef.current.style.x = (x)+"px";
    }
    if(y > 0) {
        if(y < 0) {
            y = 0;
        }
        if(draggableRef?.current) {
        draggableRef.current.style.top = (y)+"px";
        }
    }
  }
  
const myMouseUp=(event) => {
//    
    if(props && props.window && props.window.y >= 0) {
        store.dispatch( setPos( {uid:props.window.uid, x:position.x, y:position.y} ) );
        //setWindowPanel(windowPanel);
    }    
    
}

const onFocusEvent=(event) => {
    //event.preventDefault();
    if( props.window.zindex < 999 ) {
        props.window.zindex = 999;
        store.dispatch( setFocus( props.window ) );
    //return false;
        const ppcEvent = new CustomEvent(WINDOW_EVENTS.SELECTED_WINDOW, {detail: {window: props?.window} });
    
        window.dispatchEvent(ppcEvent);
    }
}
const closeWindowEvent=(event) => {
    event.preventDefault();
    
    if(props?.window?.onCloseHandler) {
        props?.window?.onCloseHandler(event, false);
    }
    
    store.dispatch( close(props.window) );
    return false;
}
let startDragPos;
let startHeight;
let element;

const mouseMovResizeHandler = (event) => {
    var newHeight = startHeight.height + (event.pageY - startDragPos.y);
    var newWidth = startHeight.width + (event.pageX - startDragPos.x);
    if(parseInt(newHeight) < parseInt(element.style.minHeight)) {
        return;
        }
    element.style.maxHeight = null;
    if(parseInt(newHeight) >= parseInt(element.style.minHeight)) {
        element.style.height = newHeight+"px";
    }
    element.style.width = newWidth+"px";

    
    
    
        
    let windowId = props?.window.uid;
    let innerPanel = document.getElementById(windowId);
    let innerPanelHeight;
    
    if(props?.window && props?.window?.resizeElements) {
        //let windowId = props?.window.uid;
        props?.window?.resizeElements.for( (item) => {
            
            let otherPanel = document.getElementById(item+"_"+windowId);
            if(otherPanel && newHeight) {
                otherPanel.style.height = (newHeight - otherPanel.offsetTop-8)+"px";  
            }
            
        } )    
    }
    
    
    
    if( innerPanel ) {
    let innerPanelHeight = newHeight - innerPanel.offsetTop - 8;
    let endPanel = document.getElementById('endPanel_'+windowId);
    if(endPanel) {
         innerPanelHeight = innerPanelHeight - endPanel.clientHeight;
    }

    
        
    let hasDynamicChildren = false;
    for(let i in innerPanel.children) {
        if(typeof innerPanel.children[i] == 'object' &&  'dynamic' in innerPanel.children[i].dataset ) {
            hasDynamicChildren = true;
            innerPanel.children[i].style.height = innerPanelHeight+"px";  
        }
        //
    }
    
    if(hasDynamicChildren) {
        if(innerPanel) {
            innerPanel.style.height = (innerPanelHeight)+"px";
            innerPanel.style.padding = "0px";
            innerPanel.parentElement.style.padding = "0px";
            //innerPanel.style.paddingTop = "0px";
        }
    }
    
    }
    
    
    //draggableRef.current.style.height = newHeight+"px";
      //      
}

const mouseUpResizeHandler = (event) => {
    element = null;
    startDragPos = null;
    startHeight = null;
    window.removeEventListener("mousemove", mouseMovResizeHandler);
    window.removeEventListener("mouseup", mouseUpResizeHandler);
 }
const onResizeWindowDragEventHandler = (event, onOrOff) => {
    if(!startDragPos && onOrOff == 1) {
            event.preventDefault();

            let windowId = props?.window.uid;
            let Element = element = document.getElementById('base_'+windowId);
            
            startDragPos = {y:event.pageY, x: event.pageX};
            if(!Element.style.height) {
                Element.style.height = Element.clientHeight;
            } else if ( Element.style.height.endsWith("%") ) {
                let windowRect = document.body.getBoundingClientRect();
                Element.style.height = ( windowRect.height/100 ) * parseInt( Element.style.height )+"px";
            }
            
            if(!Element.style.width) {
                Element.style.width = Element.clientWidth;
            } else if ( Element.style.width.endsWith("%") ) {
                let windowRect = document.body.getBoundingClientRect();
                Element.style.width = ( windowRect.width/100 ) * parseInt( Element.style.width )+"px";
            }
            
            
            startHeight = {height:((Element.style.height != "") ? parseInt(Element.style.height) : parseInt(Element.clientHeight)) , width: parseInt(Element.style.width)}
            
         
            // attach to document so mouse doesn't have to stay precisely on the 'handle'
            window.addEventListener("mousemove", mouseMovResizeHandler);
            window.addEventListener("mouseup", mouseUpResizeHandler);
        
//        startDragPos = {x:event.nativeEvent.offsetX, y: event.nativeEvent.offsetY};
//        let addWidth = startDragPos.x + event.nativeEvent.offsetX;
    } else if(onOrOff == 0) {
        startDragPos = null;
    }else if(onOrOff == 3) {
        let addWidth = startDragPos.x + event.nativeEvent.offsetX;
    }
}

    checkSizeWindow();
       return (
    <>
    {createPortal(
    <div key={props?.window?.uid} id={"base_"+props?.window.uid} ref={draggableRef} className={"window divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-xl absolute  h-500  z-["+window.zindex+"]"}
    name={"base_"+props?.window.uid}
    data-uid={props?.window.uid}
    onMouseDownCapture={onFocusEvent}  
    style={{
          top: position.y,
          left: position.x,
          zIndex: props.window.zindex,
          width: (props?.window.startWidth ? props?.window.startWidth :  (props?.window?.style?.width ? props?.window.style.width : "100%")  ),
          height: (props?.window.startHeight ? props?.window.startHeight :  (props?.window?.style?.height ? props?.window.style.height : "100%") ),
          minHeight: (props?.window.minHeight ? props?.window.minHeight :  (props?.window?.style?.minHeight ? props?.window.style.minHeight : null) ),
          minWidth: (props?.window.minWidth ? props?.window.minWidth :  (props?.window?.style?.minWidth ? props?.window.style.minWidth : null) ),
//          width: props.window.width,
//          height: props.window.height
        }}
    >
      <div className="px-2 py-2 sm:px-2  bg-blue-50 min-w-full" onMouseDown={handleMouseDown}  onMouseUp={myMouseUp}>
      <div className="flex flex-row" >
        <div class="basis-5/6 cursor-move ">{props?.window?.title}</div>
        <div className="basis-1/6 justify-items-end flex grid grid-cols-6 gap-1">
            {(Object.hasOwn(props?.window, 'resize') == false || props?.window?.resize == true) && 
          <XCircleIcon aria-hidden="true" className="flex size-5 text-green-400 cursor-pointer col-span-1 col-start-5" onClick={(event) => sizeWindowEvent(event)} />
          }
          <XCircleIcon aria-hidden="true" className="flex size-5 text-red-400 cursor-pointer col-span-1 " onClick={(event) => closeWindowEvent(event)} />
        </div>
    </div>        
              
      </div>
      <div className="windowBody py-4 px-4 min-w-full grid grid-column gap-2" name="innerPanel" id={"innerPanel_"+props?.window?.uid}>
        {props.children}
      </div>
      <div key={uuid()} >
      {props?.window?.footer}
      </div>
      {(Object.hasOwn(props?.window, 'resize') == false || props?.window?.resize == true) &&
      <button className="absolute right-0 bottom-0" 
      onMouseDown={(event) => onResizeWindowDragEventHandler(event, 1)}
//      onDragEnd={(event) => onResizeWindowDragEventHandler(event, 0)} 
//      onDrag={(event) => onResizeWindowDragEventHandler(event, 3)}
//      draggable={true} 
      >
      <ArrowUpLeftIcon aria-hidden="true" className="flex size-5 text-gray-400 cursor-pointer col-span-1 " />
      
      </button>
      }
      
    </div>,document.body)}
    </>
    );
})

export default BaseWindow;